import { Link, Subtitle } from '@joor/design-system'
import styled from 'styled-components'

import { InlineLayoutProps } from '../../types'

export const InlineLayout = ({
  title,
  linkUrl,
  linkLabel,
}: InlineLayoutProps) => {
  return (
    <StyledContainer>
      <Subtitle>{title}</Subtitle>
      <Link href={linkUrl} target="_blank">
        {linkLabel}
      </Link>
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 12px 20px;

  @media only screen and (min-width: 1366px) {
    flex-direction: row;
  }

  p {
    text-align: center !important;
  }
`
